export default defineNuxtPlugin(() => {
  const { initialize } = usePaymentFlowABTest()

  // Initialize AB test early in app lifecycle (runs on both server and client)
  initialize()
})
